// Material Dashboard 2 React examples
import React from "react";
import ApiDescription from "./ApiDescription";
import griskApiData from "./tableData";
import ScrollSpy from "react-ui-scrollspy";
import PropTypes from "prop-types";

function FundingDocs({ scrollRef, search }) {
  return (
    <div>
      <ScrollSpy
        activeClass="scrollspy-active"
        offsetBottom={100}
        scrollThrottle={80}
        parentScrollContainerRef={scrollRef}
      >
        <ApiDescription data={griskApiData} search={search} />
      </ScrollSpy>
    </div>
  );
}
FundingDocs.propTypes = {
  scrollRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }).isRequired,
  search: PropTypes.string.isRequired,
};
export default FundingDocs;
